import React from "react"
import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { SpiritLink } from "../Filtering/SpiritLink"
import SI, { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"

export interface SpiritOutcomeTableProps {
	plays: Play[]
}

export const SpiritOutcomeTable = React.memo(function (props: SpiritOutcomeTableProps): JSX.Element {

	const table = 'SpiritOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'spiritName', ascending: true }

	const tableData = SI.spirits.map(spirit => {

		const spiritPlays = props.plays.filter(play => play.spirits.some(playedSpirit => playedSpirit.spirit.name === spirit.name))
		const playCount = spiritPlays.length
		const winCount = spiritPlays.filter(play => play.outcome.victory).length
		const lossCount = playCount - winCount

		return {
			spirit,
			spiritName: spirit.nickname,
			expansionOrder: SI.expansionOrder.get(spirit.expansion),
			playCount: playCount === 0 ? null : playCount,
			winCount: playCount === 0 ? null : winCount,
			lossCount: playCount === 0 ? null : lossCount,
			winRate: playCount === 0 ? null : winCount / playCount,
		}
	})

	Sorting.sort(tableData, sort, 'expansionOrder', 'spiritName')

	return (
		<div>
			<table className="stats spirit-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'expansionOrder'} label='Spirit' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.spirit.name}>
								<th><SpiritLink spirit={row.spirit} /></th>
								<td className="victory">{row.playCount ? row.winCount : ''}</td>
								<td className="loss">{row.playCount ? row.lossCount : ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})
